import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import { EditTable } from '../../../organisms'
import AdminLayoutIndex from '../_layouts'

declare var window: interfaces.IWindow

interface IProps {
  coupons: {
    coupons: IJsonResponse
  }
}

export const LOGIC_UNIT = {
  fixed: 'yen',
  percentage: '%',
}

const LOGIC_LABEL = {
  fixed: 'Price',
  percentage: 'Percentage',
}

const getLogicLabelFromRecord = ({ logic_type, logic_value }) => {
  return `${LOGIC_LABEL[logic_type]}: ${logic_value} ${LOGIC_UNIT[logic_type]}`
}

const COLUMNS = [
  {
    name: I18n.t('generic.id'),
    field: 'id',
    required: false,
    readOnly: true,
  },
  {
    name: I18n.t('generic.name'),
    field: 'name',
    required: true,
  },
  {
    name: I18n.t('generic.comment'),
    field: 'comment',
    required: false,
  },
  {
    name: I18n.t('generic.logic'),
    field: 'logic_type',
    required: false,
    renderElement: record => <span>{getLogicLabelFromRecord(record)}</span>,
  },
  {
    name: I18n.t('generic.expiration_date'),
    field: 'expire_at',
    required: false,
  },
  {
    name: I18n.t('generic.limit'),
    field: 'limit',
    required: false,
  },
  {
    name: I18n.t('generic.usage'),
    field: 'usage',
    required: false,
  },
]

const AdminCouponIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('Admin Coupons')
  const { data, pagination } = adminService.getDataFromJson(props.coupons.coupons)
  const [coupons, setCoupons] = React.useState(data)
  const handleDelete = React.useCallback(
    async id => {
      const { flush } = await adminService.deleteCoupon(id)
      window.flashMessages.addMessage({
        text: flush.message,
        type: flush.type,
      })
      setCoupons(coupons.filter(coupon => coupon.id !== id))
    },
    [coupons]
  )

  const handleClickDelete = id => {
    if (window.confirm(I18n.t('generic.delete_confirmation'))) {
      handleDelete(id)
    }
  }

  return (
    <AdminLayoutIndex
      model="coupon"
      title={
        <Heading>
          <span>{I18n.t('generic.coupons')}</span>
          <Button small={true}>
            <a href="/admin/coupons/new">{I18n.t('generic.create_new')}</a>
          </Button>
        </Heading>
      }
      main={
        <EditTable
          editable={true}
          columns={COLUMNS}
          records={coupons}
          pagination={pagination}
          handleDelete={handleClickDelete}
          getEditLink={({ id }) => `/admin/coupons/${id}/edit`}
        />
      }
    />
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

export default AdminCouponIndex
